import angular from 'angular';
import ServicesModule from '../../../services/services';
import ResourcesModule from '../../../resources/resources';
import template from './usersEdit.jade';
import {hasStaleLogin} from './userStatus.util';

export class UsersEditController {
  /* @ngInject */
  constructor($stateParams, UsersResource, currentUser, $state, $http, api, notify) {
    this.UsersResource = UsersResource;
    this.$state = $state;
    this.$http = $http;
    this.api = api;
    this.notify = notify;
    this.isResourceBeingPersisted = false;
    currentUser.subscribe(user => this.user = user);

    if ($stateParams.id) {
      this.getResource($stateParams.id);
    } else {
      this.new = true;
      this.resource = {
        roles: ['APP_DEVELOPER']
      };
    }
  }

  getResource(id) {
    this.UsersResource.one(id).get().then((res) => {
      this.resource = res;
    });
  }

  save() {
    this.isResourceBeingPersisted = true;
    if (this.resource.id) {
      this.applyReactivateIfNeeded();
      this.update();
    } else {
      this.create();
    }
  }

  create() {
    this.UsersResource.post(this.resource)
      .then((response) => {
        let fullName = `${this.resource.first_name} ${this.resource.last_name}`;
        this.notify.created('user', fullName);
        this.$state.go("app.admin.users.edit", {id: response.id});
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  update() {
    this.resource.save()
      .then(() => {
        let fullName = `${this.resource.first_name} ${this.resource.last_name}`;
        this.notify.updated('user', fullName);
        this.$state.go("app.admin.users.edit", {id: this.resource.id});
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  showResetMfa() {
    return this.resource && this.resource.use_mfa;
  }

  showLockUser() {
    return this.user && this.user.hasRole(['ADMIN'])
  }

  canReactivateUser() {
    const isLoginStale = hasStaleLogin(this.resource);

    return this.user
      && this.user.hasRole(['ADMIN'])
      && this.resource
      && this.resource.id
      && isLoginStale;
  }

  applyReactivateIfNeeded() {
    if (!this.resource || !this.resource.reactivate_user) {
      return;
    }
    if (!this.canReactivateUser()) {
      this.resource.reactivate_user = false;
      return;
    }
    const nowIso = new Date().toISOString();
    this.resource.last_logged_in_at = nowIso;
    this.resource.reactivate_user = false;
  }

  lockUser() {
    this.resource.status = this.resource.status === 'Inactive' ? 'Active' : 'Inactive';
    this.update();
  }

  resetMfa() {
    let user = this.resource;
    this.$http.post(`${this.api.baseURL}/oauth/token/mfa/reset`, {
      username: user.email
    }, {
      headers: { 'Requested-From-Component': 'pepapi-frontend'},
    }).then((result) => {
      this.resource.use_mfa = false;
      this.notify.success('resetMfaSucceed');
    })
    .catch((response) => {
      this.notify.error('resetMfaFailed')
    })
  }

  isDemoAccount() {
    return this.resource && this.resource.id && this.resource.hasRole && this.resource.hasRole(['DEMO']);
  }
}

export function UsersEditComponent() {
  return {
    template,
    controller: UsersEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.admin.users.edit', [
  ServicesModule.name,
  ResourcesModule.name
])
.directive('usersEdit', UsersEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/users/usersEdit.js
 **/